'use client';

import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { theme } from './theme';

export type ThemeProviderProps = React.PropsWithChildren;

export function ThemeProvider(props: ThemeProviderProps) {
  return <EmotionThemeProvider theme={theme}>{props.children}</EmotionThemeProvider>;
}
